import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'diagnostic',
  },
  {
    path: 'diagnostic',
    loadChildren: () =>
      import('./features/diagnostic/diagnostic.routes').then(
        (m) => m.diagnosticRoutes,
      ),
  },
  {
    path: '**',
    redirectTo: 'diagnostic',
  },
];
